import React, { Component } from 'react';
import { array } from 'prop-types';
import { Tooltip } from 'antd';
import {
  CheckCircleFilled,
  ClockCircleFilled,
  CloseCircleFilled,
  MinusCircleOutlined
} from '@ant-design/icons';
import { orderBy } from 'lodash';

import './index.scss';

class StageTimeline extends Component {
  static propTypes = {
    stages: array
  };

  getStageIcon = (status) => {
    switch (status) {
      case 'finished':
        return <CheckCircleFilled className="stage-icon finished" />;
      case 'ongoing':
        return <ClockCircleFilled className="stage-icon ongoing" />;
      case 'cancelled':
        return <CloseCircleFilled className="stage-icon cancelled" />;
      default:
        return <MinusCircleOutlined className="stage-icon pending" />;
    }
  };

  render () {
    const { stages } = this.props;
    if (!stages || stages.length === 0) return null;

    const sorted = orderBy(stages, 'position');
    const total = sorted.length;
    const finishedCount = sorted.filter(
      (s) => s.status === 'finished'
    ).length;

    return (
      <div className="stage-timeline">
        <div className="timeline-progress-label">
          {finishedCount}/{total} etapas completadas
        </div>
        <div className="timeline-track">
          {sorted.map((stage, idx) => (
            <React.Fragment key={stage.id}>
              <Tooltip
                title={
                  <span>
                    <strong>{stage.name}</strong>
                    <br />
                    {stage.status === 'finished' && 'Completada'}
                    {stage.status === 'ongoing' && 'En curso'}
                    {stage.status === 'cancelled' && 'Cancelada'}
                    {stage.status === 'pending' && 'Pendiente'}
                  </span>
                }
              >
                <div className={`timeline-node ${stage.status}`}>
                  {this.getStageIcon(stage.status)}
                </div>
              </Tooltip>
              {idx < total - 1 && (
                <div
                  className={`timeline-connector ${
                    stage.status === 'finished' ? 'finished' : ''
                  }`}
                />
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    );
  }
}

export default StageTimeline;
